import { CONTACT_EMAIL } from "../../helpers/constants";

const PublicFooter = () => (
  <footer className="gm-public-footer">
    <div className="gm-public-footer-content">
      <nav className="gm-public-footer-links">
        <a href="/">Inicio</a>
        <a href={`mailto:${CONTACT_EMAIL}`}>Contacto</a>
      </nav>
      <div className="gm-public-footer-contact">
        ¿Tienes dudas? Escríbenos a{" "}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      </div>
      <div className="gm-public-footer-copyright">
        © {new Date().getFullYear()} Growme. Todos los derechos reservados.
      </div>
    </div>
  </footer>
);

export default PublicFooter;
